import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.error.cause.js";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-set.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import { browserTracingIntegration, WINDOW, startBrowserTracingPageLoadSpan, startBrowserTracingNavigationSpan } from '@sentry/browser';
import { logger, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, SEMANTIC_ATTRIBUTE_SENTRY_OP, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, getClient, getNumberOfUrlSegments, getCurrentScope, getActiveSpan, getRootSpan, spanToJSON } from '@sentry/core';
import * as React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { DEBUG_BUILD } from './debug-build.js';

/* eslint-disable max-lines */
// Inspired from Donnie McNeal's solution:
// https://gist.github.com/wontondon/e8c4bdf2888875e4c755712e99279536

var _useEffect;
var _useLocation;
var _useNavigationType;
var _createRoutesFromChildren;
var _matchRoutes;
var _stripBasename = false;
var CLIENTS_WITH_INSTRUMENT_NAVIGATION = new WeakSet();

/**
 * Creates a wrapCreateBrowserRouter function that can be used with all React Router v6 compatible versions.
 */
function createV6CompatibleWrapCreateBrowserRouter(createRouterFunction, version) {
  if (!_useEffect || !_useLocation || !_useNavigationType || !_matchRoutes) {
    DEBUG_BUILD && logger.warn("reactRouterV".concat(version, "Instrumentation was unable to wrap the `createRouter` function because of one or more missing parameters."));
    return createRouterFunction;
  }
  return function (routes, opts) {
    var router = createRouterFunction(routes, opts);
    var basename = opts && opts.basename;
    var activeRootSpan = getActiveRootSpan();

    // The initial load ends when `createBrowserRouter` is called.
    // This is the earliest convenient time to update the transaction name.
    // Callbacks to `router.subscribe` are not called for the initial load.
    if (router.state.historyAction === 'POP' && activeRootSpan) {
      updatePageloadTransaction(activeRootSpan, router.state.location, routes, undefined, basename);
    }
    router.subscribe(function (state) {
      var location = state.location;
      if (state.historyAction === 'PUSH' || state.historyAction === 'POP') {
        handleNavigation({
          location: location,
          routes: routes,
          navigationType: state.historyAction,
          version: version,
          basename: basename
        });
      }
    });
    return router;
  };
}

/**
 * Creates a wrapCreateMemoryRouter function that can be used with all React Router v6 compatible versions.
 */
function createV6CompatibleWrapCreateMemoryRouter(createRouterFunction, version) {
  if (!_useEffect || !_useLocation || !_useNavigationType || !_matchRoutes) {
    DEBUG_BUILD && logger.warn("reactRouterV".concat(version, "Instrumentation was unable to wrap the `createMemoryRouter` function because of one or more missing parameters."));
    return createRouterFunction;
  }
  return function (routes, opts) {
    var router = createRouterFunction(routes, opts);
    var basename = opts ? opts.basename : undefined;
    var activeRootSpan = getActiveRootSpan();
    var initialEntry = undefined;
    var initialEntries = opts ? opts.initialEntries : undefined;
    var initialIndex = opts ? opts.initialIndex : undefined;
    var hasOnlyOneInitialEntry = initialEntries && initialEntries.length === 1;
    var hasIndexedEntry = initialIndex !== undefined && initialEntries && initialEntries[initialIndex];
    initialEntry = hasOnlyOneInitialEntry ? initialEntries[0] : hasIndexedEntry ? initialEntries[initialIndex] : undefined;
    var location = initialEntry ? typeof initialEntry === 'string' ? {
      pathname: initialEntry
    } : initialEntry : router.state.location;
    if (router.state.historyAction === 'POP' && activeRootSpan) {
      updatePageloadTransaction(activeRootSpan, location, routes, undefined, basename);
    }
    router.subscribe(function (state) {
      var location = state.location;
      if (state.historyAction === 'PUSH' || state.historyAction === 'POP') {
        handleNavigation({
          location: location,
          routes: routes,
          navigationType: state.historyAction,
          version: version,
          basename: basename
        });
      }
    });
    return router;
  };
}

/**
 * Creates a browser tracing integration that can be used with all React Router v6 compatible versions.
 */
function createReactRouterV6CompatibleTracingIntegration(options, version) {
  var integration = browserTracingIntegration(_objectSpread(_objectSpread({}, options), {}, {
    instrumentPageLoad: false,
    instrumentNavigation: false
  }));
  var useEffect = options.useEffect,
    useLocation = options.useLocation,
    useNavigationType = options.useNavigationType,
    createRoutesFromChildren = options.createRoutesFromChildren,
    matchRoutes = options.matchRoutes,
    stripBasename = options.stripBasename,
    _options$instrumentPa = options.instrumentPageLoad,
    instrumentPageLoad = _options$instrumentPa === void 0 ? true : _options$instrumentPa,
    _options$instrumentNa = options.instrumentNavigation,
    instrumentNavigation = _options$instrumentNa === void 0 ? true : _options$instrumentNa;
  return _objectSpread(_objectSpread({}, integration), {}, {
    setup: function setup() {
      _useEffect = useEffect;
      _useLocation = useLocation;
      _useNavigationType = useNavigationType;
      _matchRoutes = matchRoutes;
      _createRoutesFromChildren = createRoutesFromChildren;
      _stripBasename = stripBasename || false;
    },
    afterAllSetup: function afterAllSetup(client) {
      integration.afterAllSetup(client);
      var initPathName = WINDOW && WINDOW.location && WINDOW.location.pathname;
      if (instrumentPageLoad && initPathName) {
        var _attributes;
        startBrowserTracingPageLoadSpan(client, {
          name: initPathName,
          attributes: (_attributes = {}, _defineProperty(_attributes, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, 'url'), _defineProperty(_attributes, SEMANTIC_ATTRIBUTE_SENTRY_OP, 'pageload'), _defineProperty(_attributes, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.pageload.react.reactrouter_v".concat(version)), _attributes)
        });
      }
      if (instrumentNavigation) {
        CLIENTS_WITH_INSTRUMENT_NAVIGATION.add(client);
      }
    }
  });
}
function createV6CompatibleWrapUseRoutes(origUseRoutes, version) {
  if (!_useEffect || !_useLocation || !_useNavigationType || !_matchRoutes) {
    DEBUG_BUILD && logger.warn('reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.');
    return origUseRoutes;
  }
  var allRoutes = new Set();
  var SentryRoutes = function SentryRoutes(props) {
    var isMountRenderPass = React.useRef(true);
    var routes = props.routes,
      locationArg = props.locationArg;
    var Routes = origUseRoutes(routes, locationArg);
    var location = _useLocation();
    var navigationType = _useNavigationType();

    // A value with stable identity to either pick `locationArg` if available or `location` if not
    var stableLocationParam = typeof locationArg === 'string' || locationArg && locationArg.pathname ? locationArg : location;
    _useEffect(function () {
      var normalizedLocation = typeof stableLocationParam === 'string' ? {
        pathname: stableLocationParam
      } : stableLocationParam;
      if (isMountRenderPass.current) {
        routes.forEach(function (route) {
          var extractedChildRoutes = getChildRoutesRecursively(route);
          extractedChildRoutes.forEach(function (r) {
            allRoutes.add(r);
          });
        });
        updatePageloadTransaction(getActiveRootSpan(), normalizedLocation, routes, undefined, undefined, Array.from(allRoutes));
        isMountRenderPass.current = false;
      } else {
        handleNavigation({
          location: normalizedLocation,
          routes: routes,
          navigationType: navigationType,
          version: version,
          allRoutes: Array.from(allRoutes)
        });
      }
    }, [navigationType, stableLocationParam]);
    return Routes;
  };

  // eslint-disable-next-line react/display-name
  return function (routes, locationArg) {
    return /*#__PURE__*/React.createElement(SentryRoutes, {
      routes: routes,
      locationArg: locationArg
    });
  };
}
function handleNavigation(opts) {
  var location = opts.location,
    routes = opts.routes,
    navigationType = opts.navigationType,
    version = opts.version,
    matches = opts.matches,
    basename = opts.basename,
    allRoutes = opts.allRoutes;
  var branches = Array.isArray(matches) ? matches : _matchRoutes(routes, location, basename);
  var client = getClient();
  if (!client || !CLIENTS_WITH_INSTRUMENT_NAVIGATION.has(client)) {
    return;
  }
  if ((navigationType === 'PUSH' || navigationType === 'POP') && branches) {
    var _attributes2;
    var name,
      source = 'url';
    var isInDescendantRoute = locationIsInsideDescendantRoute(location, allRoutes || routes);
    if (isInDescendantRoute) {
      name = prefixWithSlash(rebuildRoutePathFromAllRoutes(allRoutes || routes, location));
      source = 'route';
    }
    if (!isInDescendantRoute || !name) {
      var _getNormalizedName = getNormalizedName(routes, location, branches, basename);
      var _getNormalizedName2 = _slicedToArray(_getNormalizedName, 2);
      name = _getNormalizedName2[0];
      source = _getNormalizedName2[1];
    }
    startBrowserTracingNavigationSpan(client, {
      name: name,
      attributes: (_attributes2 = {}, _defineProperty(_attributes2, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, source), _defineProperty(_attributes2, SEMANTIC_ATTRIBUTE_SENTRY_OP, 'navigation'), _defineProperty(_attributes2, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, "auto.navigation.react.reactrouter_v".concat(version)), _attributes2)
    });
  }
}

/**
 * Strip the basename from a pathname if exists.
 *
 * Vendored and modified from `react-router`
 * https://github.com/remix-run/react-router/blob/462bb712156a3f739d6139a0f14810b76b002df6/packages/router/utils.ts#L1038
 */
function stripBasenameFromPathname(pathname, basename) {
  if (!basename || basename === '/') {
    return pathname;
  }
  if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) {
    return pathname;
  }

  // We want to leave trailing slash behavior in the user's control, so if they
  // specify a basename with a trailing slash, we should support it
  var startIndex = basename.endsWith('/') ? basename.length - 1 : basename.length;
  var nextChar = pathname.charAt(startIndex);
  if (nextChar && nextChar !== '/') {
    // pathname does not start with basename/
    return pathname;
  }
  return pathname.slice(startIndex) || '/';
}
function sendIndexPath(pathBuilder, pathname, basename) {
  var reconstructedPath = pathBuilder || _stripBasename ? stripBasenameFromPathname(pathname, basename) : pathname;
  var formattedPath =
  // If the path ends with a slash, remove it
  reconstructedPath[reconstructedPath.length - 1] === '/' ? reconstructedPath.slice(0, -1) :
  // If the path ends with a wildcard, remove it
  reconstructedPath.slice(-2) === '/*' ? reconstructedPath.slice(0, -1) : reconstructedPath;
  return [formattedPath, 'route'];
}
function pathEndsWithWildcard(path) {
  return path.endsWith('*');
}
function pathIsWildcardAndHasChildren(path, branch) {
  return pathEndsWithWildcard(path) && branch.route.children && branch.route.children.length > 0 || false;
}
function routeIsDescendant(route) {
  return !!(!route.children && route.element && route.path && route.path.endsWith('/*'));
}
function locationIsInsideDescendantRoute(location, routes) {
  var matchedRoutes = _matchRoutes(routes, location);
  if (matchedRoutes) {
    var _iterator = _createForOfIteratorHelper(matchedRoutes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var match = _step.value;
        if (routeIsDescendant(match.route) && pickSplat(match)) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return false;
}
function getChildRoutesRecursively(route) {
  var allRoutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
  if (!allRoutes.has(route)) {
    allRoutes.add(route);
    if (route.children && !route.index) {
      route.children.forEach(function (child) {
        var childRoutes = getChildRoutesRecursively(child, allRoutes);
        childRoutes.forEach(function (r) {
          return allRoutes.add(r);
        });
      });
    }
  }
  return allRoutes;
}
function pickPath(match) {
  return trimWildcard(match.route.path || '');
}
function pickSplat(match) {
  return match.params['*'] || '';
}
function trimWildcard(path) {
  return path[path.length - 1] === '*' ? path.slice(0, -1) : path;
}
function trimSlash(path) {
  return path[path.length - 1] === '/' ? path.slice(0, -1) : path;
}
function prefixWithSlash(path) {
  return path[0] === '/' ? path : "/".concat(path);
}
function rebuildRoutePathFromAllRoutes(allRoutes, location) {
  var matchedRoutes = _matchRoutes(allRoutes, location);
  if (!matchedRoutes || matchedRoutes.length === 0) {
    return '';
  }
  var _iterator2 = _createForOfIteratorHelper(matchedRoutes),
    _step2;
  try {
    var _loop = function _loop() {
      var match = _step2.value;
      if (match.route.path && match.route.path !== '*') {
        var path = pickPath(match);
        var strippedPath = stripBasenameFromPathname(location.pathname, prefixWithSlash(match.pathnameBase));
        return {
          v: trimSlash(trimSlash(path || '') + prefixWithSlash(rebuildRoutePathFromAllRoutes(allRoutes.filter(function (route) {
            return route !== match.route;
          }), {
            pathname: strippedPath
          })))
        };
      }
    };
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _ret = _loop();
      if (_typeof(_ret) === "object") return _ret.v;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return '';
}
function getNormalizedName(routes, location, branches) {
  var basename = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  if (!routes || routes.length === 0) {
    return [_stripBasename ? stripBasenameFromPathname(location.pathname, basename) : location.pathname, 'url'];
  }
  var pathBuilder = '';
  if (branches) {
    var _iterator3 = _createForOfIteratorHelper(branches),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var branch = _step3.value;
        var route = branch.route;
        if (route) {
          // Early return if index route
          if (route.index) {
            return sendIndexPath(pathBuilder, branch.pathname, basename);
          }
          var path = route.path;

          // If path is not a wildcard and has no child routes, append the path
          if (path && !pathIsWildcardAndHasChildren(path, branch)) {
            var newPath = path[0] === '/' || pathBuilder[pathBuilder.length - 1] === '/' ? path : "/".concat(path);
            pathBuilder = trimSlash(pathBuilder) + prefixWithSlash(newPath);

            // If the path matches the current location, return the path
            if (trimSlash(location.pathname) === trimSlash(basename + branch.pathname)) {
              if (
              // If the route defined on the element is something like
              // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
              // We should check against the branch.pathname for the number of / separators
              // TODO(v9): Put the implementation of `getNumberOfUrlSegments` in this file
              // eslint-disable-next-line deprecation/deprecation
              getNumberOfUrlSegments(pathBuilder) !== getNumberOfUrlSegments(branch.pathname) &&
              // We should not count wildcard operators in the url segments calculation
              !pathEndsWithWildcard(pathBuilder)) {
                return [(_stripBasename ? '' : basename) + newPath, 'route'];
              }

              // if the last character of the pathbuilder is a wildcard and there are children, remove the wildcard
              if (pathIsWildcardAndHasChildren(pathBuilder, branch)) {
                pathBuilder = pathBuilder.slice(0, -1);
              }
              return [(_stripBasename ? '' : basename) + pathBuilder, 'route'];
            }
          }
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  var fallbackTransactionName = _stripBasename ? stripBasenameFromPathname(location.pathname, basename) : location.pathname || '/';
  return [fallbackTransactionName, 'url'];
}
function updatePageloadTransaction(activeRootSpan, location, routes, matches, basename, allRoutes) {
  var branches = Array.isArray(matches) ? matches : _matchRoutes(routes, location, basename);
  if (branches) {
    var name,
      source = 'url';
    var isInDescendantRoute = locationIsInsideDescendantRoute(location, allRoutes || routes);
    if (isInDescendantRoute) {
      name = prefixWithSlash(rebuildRoutePathFromAllRoutes(allRoutes || routes, location));
      source = 'route';
    }
    if (!isInDescendantRoute || !name) {
      var _getNormalizedName3 = getNormalizedName(routes, location, branches, basename);
      var _getNormalizedName4 = _slicedToArray(_getNormalizedName3, 2);
      name = _getNormalizedName4[0];
      source = _getNormalizedName4[1];
    }
    getCurrentScope().setTransactionName(name);
    if (activeRootSpan) {
      activeRootSpan.updateName(name);
      activeRootSpan.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, source);
    }
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createV6CompatibleWithSentryReactRouterRouting(Routes, version) {
  if (!_useEffect || !_useLocation || !_useNavigationType || !_createRoutesFromChildren || !_matchRoutes) {
    DEBUG_BUILD && logger.warn("reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.\n      useEffect: ".concat(_useEffect, ". useLocation: ").concat(_useLocation, ". useNavigationType: ").concat(_useNavigationType, ".\n      createRoutesFromChildren: ").concat(_createRoutesFromChildren, ". matchRoutes: ").concat(_matchRoutes, "."));
    return Routes;
  }
  var allRoutes = new Set();
  var SentryRoutes = function SentryRoutes(props) {
    var isMountRenderPass = React.useRef(true);
    var location = _useLocation();
    var navigationType = _useNavigationType();
    _useEffect(function () {
      var routes = _createRoutesFromChildren(props.children);
      if (isMountRenderPass.current) {
        routes.forEach(function (route) {
          var extractedChildRoutes = getChildRoutesRecursively(route);
          extractedChildRoutes.forEach(function (r) {
            allRoutes.add(r);
          });
        });
        updatePageloadTransaction(getActiveRootSpan(), location, routes, undefined, undefined, Array.from(allRoutes));
        isMountRenderPass.current = false;
      } else {
        handleNavigation({
          location: location,
          routes: routes,
          navigationType: navigationType,
          version: version,
          allRoutes: Array.from(allRoutes)
        });
      }
    },
    // `props.children` is purposely not included in the dependency array, because we do not want to re-run this effect
    // when the children change. We only want to start transactions when the location or navigation type change.
    [location, navigationType]);

    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return /*#__PURE__*/React.createElement(Routes, _objectSpread({}, props));
  };
  hoistNonReactStatics(SentryRoutes, Routes);

  // @ts-expect-error Setting more specific React Component typing for `R` generic above
  // will break advanced type inference done by react router params
  return SentryRoutes;
}
function getActiveRootSpan() {
  var span = getActiveSpan();
  var rootSpan = span ? getRootSpan(span) : undefined;
  if (!rootSpan) {
    return undefined;
  }
  var op = spanToJSON(rootSpan).op;

  // Only use this root span if it is a pageload or navigation span
  return op === 'navigation' || op === 'pageload' ? rootSpan : undefined;
}
export { createReactRouterV6CompatibleTracingIntegration, createV6CompatibleWithSentryReactRouterRouting, createV6CompatibleWrapCreateBrowserRouter, createV6CompatibleWrapCreateMemoryRouter, createV6CompatibleWrapUseRoutes, handleNavigation };